<div class="action-icons">
    <div class="consultation">
        <button *ngIf="patient.patient" (click)="openContact()" mat-icon-button matTooltip="Consultation" class="favorite-icon" aria-label="Open current contact">
            <fa-icon [icon]="['fas', 'file-medical']" class="action-fa-icon" [ngClass]="{ 'have-consultation' : prescriptionui.consultation }" size="lg"></fa-icon>
        </button>            
    </div>
    <div class="prescription">
        <button *ngIf="patient.patient" (click)="openPrescription()" mat-icon-button matTooltip="Prescription" class="favorite-icon" aria-label="Open current prescription">
            <fa-icon [icon]="['fas', 'file-prescription']" class="action-fa-icon" [ngClass]="{ 'have-prescription' : prescriptionui.prescription }" size="lg"></fa-icon>
        </button>
    </div>
</div>